import { render, staticRenderFns } from "./Gamesets.vue?vue&type=template&id=23866ab0&scoped=true&"
import script from "./Gamesets.vue?vue&type=script&lang=js&"
export * from "./Gamesets.vue?vue&type=script&lang=js&"
import style0 from "./Gamesets.vue?vue&type=style&index=0&id=23866ab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23866ab0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VApp,VBtn,VDataTable,VIcon})
